import { hotComics, newComics, categories, testimonials } from './home';
import type { Comic } from './home';

export { hotComics, newComics, categories, testimonials };
export type { Comic };

export const allComics: (Comic & {
  description: string;
  status: string;
  updateDate: string;
})[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Dubu',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20blue%20eyes%2C%20anime%20art%20style%2C%20dynamic%20pose%2C%20dramatic%20lighting%20from%20behind%2C%20dark%20fantasy%20theme%2C%20digital%20illustration%20with%20clean%20background%2C%20webtoon%20cover%20aesthetic&width=400&height=560&seq=detail-comic-01&orientation=portrait',
    category: '热血',
    slug: 'action',
    chapters: 201,
    rating: 9.8,
    isHot: true,
    isNew: false,
    description: '在一个突然出现"门"的世界里，猎人成为了对抗怪物的职业。E级猎人成振宇被认为是"人类最弱兵器"，但在一次必死的任务后，他获得了神秘系统的力量——"玩家"系统。从此，他从最弱开始一步步变强，踏上成为最强猎人的道路。这个充满激情与热血的成长故事，凭借精美的画风和扣人心弦的剧情引爆全球。',
    status: '已完结',
    updateDate: '2026-07-01',
  },
  {
    id: 2,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20featuring%20a%20calm%20male%20protagonist%20wearing%20a%20white%20coat%20holding%20a%20book%2C%20mysterious%20atmosphere%2C%20soft%20golden%20light%2C%20fantasy%20theme%2C%20clean%20composition%2C%20digital%20illustration%2C%20Korean%20manhwa%20style&width=400&height=560&seq=detail-comic-02&orientation=portrait',
    category: '奇幻',
    slug: 'fantasy',
    chapters: 186,
    rating: 9.7,
    isHot: true,
    isNew: false,
    description: '金独子是唯一一个读完了一部长达3149话的网络小说《在灭亡的世界中生存的三种方法》的人。当小说中的末日场景在现实中上演时，他凭借对剧情的全知，踏上了改变命运的道路。在这个崩塌的世界里，他将如何利用自己的知识来拯救他人、挑战既定的命运？',
    status: '连载中',
    updateDate: '2026-07-02',
  },
  {
    id: 3,
    title: '剑尊归来',
    author: 'Biga / LICO',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20swordsman%20with%20long%20black%20hair%20in%20traditional%20martial%20arts%20robe%2C%20holding%20a%20glowing%20sword%2C%20oriental%20fantasy%20theme%2C%20dramatic%20composition%2C%20ink%20wash%20painting%20influence%2C%20digital%20art%2C%20elegant%20style&width=400&height=560&seq=detail-comic-03&orientation=portrait',
    category: '武侠',
    slug: 'martial-arts',
    chapters: 154,
    rating: 9.6,
    isHot: true,
    isNew: false,
    description: '剑尊陈幽冥在修炼至顶峰后陨落，却意外重生回到少年时代。带着前世数百年的记忆与剑道感悟，他重返江湖。这一次，他要保护曾经失去的一切，守护那些爱他和他爱的人。剑锋所指，无人能挡——一段荡气回肠的江湖传奇，就此揭开序幕。',
    status: '连载中',
    updateDate: '2026-07-03',
  },
  {
    id: 4,
    title: 'SSS级重生猎人',
    author: 'Neida / Bill K.',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20of%20a%20young%20male%20hunter%20with%20silver%20hair%20and%20a%20determined%20expression%2C%20wearing%20modern%20combat%20gear%2C%20dungeon%20theme%2C%20action%20pose%2C%20vibrant%20colors%2C%20digital%20illustration%2C%20manhwa%20cover%20style&width=400&height=560&seq=detail-comic-04&orientation=portrait',
    category: '热血',
    slug: 'action',
    chapters: 132,
    rating: 9.5,
    isHot: true,
    isNew: false,
    description: '在猎人世界中默默无闻的E级猎人韩振浩，在一次SSS级副本团灭后重生。带着前世的记忆和战斗经验，他决定从头开始，成为最强的猎人。凭借着对未来的预知能力和非凡的战斗天赋，他将改写自己的命运，一步步登上猎人的巅峰。',
    status: '连载中',
    updateDate: '2026-07-02',
  },
  {
    id: 5,
    title: '绝世神医',
    author: 'Han Yoo-rang',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20handsome%20doctor%20in%20traditional%20Korean%20hanbok%20with%20medical%20tools%2C%20historical%20fantasy%20setting%2C%20soft%20warm%20lighting%2C%20romance%20theme%2C%20elegant%20composition%2C%20digital%20art%2C%20clean%20background&width=400&height=560&seq=detail-comic-05&orientation=portrait',
    category: '古风',
    slug: 'martial-arts',
    chapters: 28,
    rating: 9.3,
    isHot: false,
    isNew: true,
    description: '现代顶尖外科医生林逸在一次意外中穿越到古代，成为一个落魄医馆的继承人。凭借超前的医学知识和精湛的医术，他在古代展开了一段传奇人生的旅程。在这条路上，他不仅收获了众人的敬仰，更意外卷入宫廷的权谋斗争之中。',
    status: '连载中',
    updateDate: '2026-07-03',
  },
  {
    id: 6,
    title: '恶女的重生',
    author: 'Sol-leks / Ant Studio',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20featuring%20a%20beautiful%20female%20noble%20with%20long%20red%20hair%20in%20elegant%20Victorian%20style%20dress%2C%20regal%20posture%2C%20romance%20fantasy%2C%20dramatic%20lighting%2C%20manhwa%20art%20style&width=400&height=560&seq=detail-comic-06&orientation=portrait',
    category: '恋爱',
    slug: 'romance',
    chapters: 45,
    rating: 9.4,
    isHot: false,
    isNew: true,
    description: '人人都说她是帝国第一恶女——蕾蒂西亚·冯·艾森伯格。在被处以死刑后，她重生回到了十年前。这一次，她决定不再做那个任人摆布的棋子。她要用自己的方式改写命运，向那些曾经伤害过她的人一一复仇。然而，那位曾经亲手杀死她的骑士，似乎也隐藏着什么不为人知的秘密……',
    status: '连载中',
    updateDate: '2026-07-01',
  },
  {
    id: 7,
    title: '入魔的魔法师',
    author: 'Park Jin-seok',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20of%20a%20dark%20mage%20with%20purple%20energy%20surrounding%20him%2C%20wearing%20a%20dark%20robe%2C%20magical%20circles%20in%20background%2C%20dark%20fantasy%20theme%2C%20mysterious%20atmosphere%2C%20digital%20illustration%2C%20dramatic%20composition&width=400&height=560&seq=detail-comic-07&orientation=portrait',
    category: '奇幻',
    slug: 'fantasy',
    chapters: 67,
    rating: 9.2,
    isHot: false,
    isNew: true,
    description: '天才魔法师凯尔在一次魔法实验中遭遇意外，被黑暗能量侵蚀。所有人都以为他堕入了魔道，被逐出魔法学院。但只有他自己知道，那股黑暗能量中藏着一个惊天的秘密——关于这个世界真相的秘密。为了揭开真相，他踏上了亦正亦邪的独行之路。',
    status: '连载中',
    updateDate: '2026-07-02',
  },
  {
    id: 8,
    title: '校园特工',
    author: 'Kim Hyun-soo',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20teenage%20boy%20in%20school%20uniform%20with%20a%20cool%20expression%2C%20holding%20a%20smartphone%2C%20modern%20school%20setting%2C%20action%20comedy%20theme%2C%20bright%20colors%2C%20digital%20art%2C%20youthful%20vibe&width=400&height=560&seq=detail-comic-08&orientation=portrait',
    category: '校园',
    slug: 'school',
    chapters: 89,
    rating: 9.1,
    isHot: false,
    isNew: true,
    description: '普通高中生李在民某天突然被国家情报院招募成为少年特工——因为他拥有超群的计算机黑客天赋。白天他是普通学生，夜晚他化身为网络世界的正义战士。在校园生活与特工任务之间，他将经历一段充满欢笑、热血与成长的青春故事。',
    status: '连载中',
    updateDate: '2026-06-30',
  },
];

export interface SubCategory {
  id: number;
  name: string;
  slug: string;
  count: number;
}

export const categorySubCategories: Record<string, {
  title: string;
  description: string;
  image: string;
  subCategories: SubCategory[];
}> = {
  action: {
    title: '热血动作',
    description: '充满激情的战斗场面、跌宕起伏的冒险旅程，热血动作漫画带你体验最刺激的视觉冲击与心灵震撼。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20scene%20with%20dynamic%20fighting%20pose%2C%20two%20characters%20in%20intense%20combat%2C%20speed%20lines%2C%20explosive%20effects%2C%20warm%20orange%20and%20red%20color%20palette%2C%20digital%20illustration%2C%20manhwa%20style%2C%20clean%20composition&width=600&height=400&seq=cat-action&orientation=landscape',
    subCategories: [
      { id: 101, name: '战斗冒险', slug: 'battle', count: 98 },
      { id: 102, name: '英雄成长', slug: 'hero', count: 85 },
      { id: 103, name: '超能格斗', slug: 'superpower', count: 72 },
      { id: 104, name: '热血竞技', slug: 'sports', count: 71 },
    ],
  },
  romance: {
    title: '恋爱甜宠',
    description: '甜蜜的邂逅、心动的情感，恋爱甜宠漫画为你描绘最美的爱情故事，每一页都充满温暖与感动。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20scene%20with%20two%20characters%20sharing%20a%20gentle%20moment%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20lighting%2C%20romantic%20atmosphere%2C%20digital%20art%2C%20manhwa%20style%2C%20sweet%20and%20tender%20mood&width=600&height=400&seq=cat-romance&orientation=landscape',
    subCategories: [
      { id: 201, name: '甜宠日常', slug: 'sweet', count: 134 },
      { id: 202, name: '古风恋爱', slug: 'historical', count: 89 },
      { id: 203, name: '校园恋爱', slug: 'school-love', count: 112 },
      { id: 204, name: '重生逆袭', slug: 'rebirth', count: 123 },
    ],
  },
  fantasy: {
    title: '奇幻冒险',
    description: '踏入神秘的奇幻世界，与魔法师和勇士一起冒险。奇幻冒险漫画带你领略无限想象的魅力。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20world%20with%20a%20magical%20landscape%2C%20floating%20islands%2C%20crystal%20towers%2C%20mystical%20creatures%2C%20warm%20golden%20and%20teal%20color%20scheme%2C%20digital%20illustration%2C%20manhwa%20style%2C%20grand%20scale&width=600&height=400&seq=cat-fantasy&orientation=landscape',
    subCategories: [
      { id: 301, name: '剑与魔法', slug: 'sword-magic', count: 88 },
      { id: 302, name: '穿越异世界', slug: 'isekai', count: 103 },
      { id: 303, name: '修仙玄幻', slug: 'cultivation', count: 56 },
      { id: 304, name: '魔幻史诗', slug: 'epic', count: 42 },
    ],
  },
  'martial-arts': {
    title: '武侠江湖',
    description: '刀光剑影、侠骨柔情，武侠江湖漫画传承东方武侠文化之精髓，谱写一段段可歌可泣的江湖传奇。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20scene%20with%20a%20warrior%20in%20traditional%20clothing%20standing%20on%20a%20misty%20mountain%20peak%2C%20ink%20wash%20style%2C%20oriental%20aesthetic%2C%20bamboo%20forest%20background%2C%20digital%20art%2C%20elegant%20composition&width=600&height=400&seq=cat-martial&orientation=landscape',
    subCategories: [
      { id: 401, name: '剑道修行', slug: 'sword', count: 65 },
      { id: 402, name: '江湖恩怨', slug: 'jianghu', count: 72 },
      { id: 403, name: '武道争霸', slug: 'martial', count: 38 },
      { id: 404, name: '古风权谋', slug: 'ancient', count: 28 },
    ],
  },
  mystery: {
    title: '悬疑推理',
    description: '扑朔迷离的案件、出人意料的真相，悬疑推理漫画挑战你的逻辑思维极限，让你在每一个反转中惊叹不已。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20scene%20with%20a%20detective%20character%20in%20trench%20coat%2C%20dark%20alley%20with%20street%20lamp%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20digital%20illustration%2C%20manhwa%20style%2C%20suspenseful%20mood&width=600&height=400&seq=cat-mystery&orientation=landscape',
    subCategories: [
      { id: 501, name: '侦探破案', slug: 'detective', count: 48 },
      { id: 502, name: '心理惊悚', slug: 'thriller', count: 55 },
      { id: 503, name: '犯罪悬疑', slug: 'crime', count: 32 },
      { id: 504, name: '灵异恐怖', slug: 'horror', count: 21 },
    ],
  },
  school: {
    title: '校园青春',
    description: '青涩的校园时光、纯真的青春记忆，校园青春漫画带你回到那段最美好的岁月，感受青春的热血与温暖。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20life%20scene%20with%20students%20in%20uniform%20walking%20through%20a%20sunny%20campus%2C%20cherry%20blossom%20trees%2C%20youthful%20energy%2C%20bright%20and%20warm%20colors%2C%20digital%20art%2C%20manhwa%20style%2C%20fresh%20atmosphere&width=600&height=400&seq=cat-school&orientation=landscape',
    subCategories: [
      { id: 601, name: '校园日常', slug: 'daily', count: 102 },
      { id: 602, name: '青春成长', slug: 'growth', count: 76 },
      { id: 603, name: '搞笑校园', slug: 'comedy', count: 58 },
      { id: 604, name: '社团活动', slug: 'club', count: 42 },
    ],
  },
};

export const aboutData = {
  brandStory: {
    title: '关于韩漫屋',
    subtitle: '为每一位漫迷打造温馨的阅读空间',
    paragraphs: [
      '韩漫屋创立于2020年，是一家专注于韩国漫画在线阅读的平台。我们致力于为中文读者提供最优质的韩国漫画阅读体验，从最初只有几十部作品的小网站，逐步发展成为一个拥有超过3,200部漫画作品的阅读平台。',
      '我们的团队由一群热爱漫画的年轻人组成，每一位成员都是狂热的漫画爱好者。正是因为这份热爱，我们深知漫迷们真正需要的是什么——优质的翻译、流畅的阅读体验、及时的更新速度，以及一个能够沉浸其中的阅读空间。',
      '三年来，韩漫屋始终坚持"免费、高品质、快更新"的理念，获得了超过50万用户的信赖与支持。我们相信，好的漫画不应该有门槛，每一位热爱漫画的人都应该能够自由地享受阅读的乐趣。',
    ],
  },
  platformStats: [
    { label: '漫画作品', value: '3,200+', icon: 'ri-book-open-line' },
    { label: '忠实用户', value: '50万+', icon: 'ri-user-heart-line' },
    { label: '日更新量', value: '100+', icon: 'ri-refresh-line' },
    { label: '运营年限', value: '3年+', icon: 'ri-calendar-check-line' },
  ],
  businessInfo: {
    title: '商务合作',
    subtitle: '欢迎与我们携手合作，共创美好未来',
    contactItems: [
      { label: '商务合作邮箱', value: 'hello@fkyy11.com', icon: 'ri-mail-line' },
      { label: '版权合作邮箱', value: 'hello@fkyy11.com', icon: 'ri-copyright-line' },
      { label: '广告投放邮箱', value: 'hello@fkyy11.com', icon: 'ri-advertisement-line' },
      { label: '在线客服邮箱', value: 'hello@fkyy11.com', icon: 'ri-customer-service-2-line' },
    ],
    description: '韩漫屋期待与优秀的版权方、作者、广告主建立长期稳定的合作关系。无论您是想要引进作品的版权方、寻求合作的创作者，还是希望在我们平台进行品牌推广的企业，我们都能为您提供专业、高效的解决方案。',
  },
};